module.exports = __webpack_public_path__ + "static/media/em-06.77f91fee.png";